var cilArrowRight = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='359.873 121.377 337.246 144.004 433.243 240.001 16 240.001 16 240.002 16 272.001 16 272.002 433.24 272.002 337.246 367.996 359.873 390.623 494.498 256 359.873 121.377' class='ci-primary'/>"];

export { cilArrowRight };
